import { render, staticRenderFns } from "./Application-answer.vue?vue&type=template&id=b11460b2&"
import script from "./Application-answer.vue?vue&type=script&lang=js&"
export * from "./Application-answer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports